export default __webpack_public_path__ + "static/media/MUJER8.e412025a.png";